import { IInventoryCounter } from './IInventoryCounter';
import { IInventoryDetailUniqueItem } from './IInventoryDetailUniqueItem';
import { IInventoryItem } from './IInventoryItem';

export class IInventoryCountDetail {
  inventoryCountDetailId: string;
  inventoryCountDetailUniqueItems: IInventoryDetailUniqueItem[];
  inventoryCountId: string;
  inventoryCounters: IInventoryCounter[];
  item: IInventoryItem;
  serialNumber: string;
  expDate: string;
  recommendedInventoryLevel: number;
  recommendedInventoryLevelModifiedBy: string;
  recommendedInventoryLevelModifiedDate: string;
  mobilizationFinalCount: number;
  mobilizationInitialCount: number;
  mobilizationInitialCountModifiedBy: string;
  mobilizationInitialCountModifiedDate: string;
  mobilizationOrdered: number;
  mobilizationOrderedModifiedBy: string;
  mobilizationOrderedModifiedDate: string;
  mobilizationReceived: number;
  mobilizationReceivedModifiedBy: string;
  mobilizationReceivedModifiedDate: string;
  mobilizationTetheringNeeded: number;
  mobilizationTetheringNeededModifiedBy: string;
  mobilizationTetheringNeededModifiedDate: string;
  mobilizationTetheringOrdered: number;
  mobilizationTetheringOrderedModifiedBy: string;
  mobilizationTetheringOrderedModifiedDate: string;
  mobilizationTetheringReceived: number;
  mobilizationTetheringReceivedModifiedBy: string;
  mobilizationTetheringReceivedModifiedDate: string;
  mobilizationBroken: number;
  mobilizationBrokenModifiedBy: string;
  mobilizationBrokenModifiedDate: string;
  mobilizationOver: number;
  mobilizationShort: number;
  mobilizationPulled: number;
  mobilizationPulledModifiedBy: string;
  mobilizationPulledModifiedDate: string;
  mobilizationReturned: number;
  mobilizationReturnedModifiedBy: string;
  mobilizationReturnedModifiedDate: string;
  initialFieldCount: number;
  initialFieldCountModifiedBy: string;
  initialFieldCountModifiedDate: string;
  finalFieldCount: number;
  finalFieldCountModifiedBy: string;
  finalFieldCountModifiedDate: string;
  initialCount: number;
  initialCountModifiedBy: string;
  initialCountModifiedDate: string;
  broken: number;
  brokenModifiedBy: string;
  brokenModifiedDate: string;
  over: number;
  short: number;
  pulled: number;
  pulledModifiedBy: string;
  pulledModifiedDate: string;
  returned: number;
  returnedModifiedBy: string;
  returnedModifiedDate: string;
  ordered: number;
  orderedModifiedBy: string;
  orderedModifiedDate: string;
  received: number;
  receivedModifiedBy: string;
  receivedModifiedDate: string;
  tetheringNeeded: number;
  tetheringNeededModifiedBy: string;
  tetheringNeededModifiedDate: string;
  tetheringOrdered: number;
  tetheringOrderedModifiedBy: string;
  tetheringOrderedModifiedDate: string;
  tetheringReceived: number;
  tetheringReceivedModifiedBy: string;
  tetheringReceivedModifiedDate: string;
  adjustedRecommendedInventoryLevel: number;
  adjustedRecommendedInventoryLevelModifiedBy: string;
  adjustedRecommendedInventoryLevelModifiedDate: string;
  modifiedBy: string;
  modifiedDate: string;
  isActive: boolean;
  countNotes: string;
}
